// src/components/WhatWeOfferPage.js
import React, { useEffect, useRef } from 'react';
import LeftDetails from './LeftDetails';
import RightDetails from './RightDetails';
// import AnimatedBookCallButton from '../BookCall/AnimatedBookCallButton.tsx';

export default function WhatWeOfferPage() {
  const rightRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      if (rightRef.current) {
        rightRef.current.scrollTop += e.deltaY;  // sync scroll with right div
      }
    };
    const section = document.getElementById("scroll-target");
    section.addEventListener("wheel", handleWheel);
    return () => section.removeEventListener("wheel", handleWheel);
  }, []);

  return (
    <section id="scroll-target" className="pt-20" style={{ backgroundColor: "rgba(199, 212, 249, 0.3)" }}>
      {/* Fixed Book Call Button */}
      <div style={{
        position: "fixed",
        bottom: "2rem",
        right: "2rem",
        zIndex: 2000, // High z-index to ensure it's above all content
        pointerEvents: "auto"
      }}>

      </div>
      <div className="min-h-screen py-16 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8">
          {/* Left Part */}
          <div className="md:w-1/2 md:sticky md:top-20 h-fit overflow-hidden">
            <LeftDetails />
          </div>
          {/* Right Part */}
          <div
            ref={rightRef}
            className="md:w-1/2 max-h-[80vh] overflow-y-auto pr-2 custom-scroll"
          >
            <RightDetails />
          </div>
        </div>
      </div>
    </section>
  );
}
